<template>
  <div class="pc-view-block">
    <div class="head flex-between">
      <h1>{{ $t("home.blockTitle") }}</h1>
      <router-link to="/blockList" class="link">{{
        $t("home.viewAll")
      }}</router-link>
    </div>
    <div class="block-area">
      <div
        class="block-item flex-between"
        v-for="(item, index) in blockList"
        :key="index"
      >
        <router-link :to="`/block/${item.height}`" class="height-box">{{
          item.height
        }}</router-link>
        <div class="middle flex-left-between-stright">
          <p>
            {{ $t("home.minerAdr") }}：
            <router-link
              :to="`/address/${item.minerHash}`"
              class="light hash"
              >{{ item.minerHash | filterHash(8) }}</router-link
            >
          </p>
          <p>
            <span class="light txcount"
              >{{ item.txs.length }}
              {{ item.txs.length == 1 ? $t("home.tx") : $t("home.txs") }}</span
            >
            <count class="count-down grey" :time="item.blockTime"></count>
          </p>
        </div>
        <div class="reward flex-left-between-stright">
          <p class="grey">{{ $t("home.mineRevenue") }}</p>
          <p>
            8 BTY
            <span class="grey"
              >（{{ $t("home.miner") }}5 + {{ $t("home.fund") }}3）</span
            >
          </p>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import blockBase from "@/mixins/Home/blockList.js";
import Count from "@/components/Count.vue";
export default {
  mixins: [blockBase],
  components: {
    Count,
  },
};
</script>

<style lang="scss" scoped>
.pc-view-block {
  width: 585px;
  display: inline-block;
  .head {
    h1 {
      font-size: 16px;
      font-family: PingFangSC-Medium;
      font-weight: 600;
      color: $black;
      line-height: 22px;
    }
    .link {
      color: $orange;
    }
  }
  .block-area {
    margin-top: 25px;
    height: 542px;
    width: 100%;
    box-shadow: 4px 5px 17px 0px rgba(245, 245, 245, 0.8);
    .block-item {
      width: 100%;
      height: 90px;
      padding: 20px 40px 20px 20px;
      background: $white;
      border-bottom: 1px solid $border;
      color: $black;
      .height-box {
        height: 51px;
        min-width: fit-content;
        padding: 0 10px;
        line-height: 51px;
        text-align: center;
        color: $white;
        font-size: 14px;
        background: $blue;
        border-radius: 2px;
        cursor: pointer;
        transition: 0.3s;
      }
      .height-box:hover {
        background: $hover_blue;
      }
      .middle {
        height: 100%;
        font-size: 14px;
        margin-left: 20px;
        .hash {
          display: inline-block;
          cursor: pointer;
          min-width: 130px;
        }
        .txcount {
          display: inline-block;
          min-width: 75px;
        }
      }
      .grey {
        color: $grey;
      }
      .reward {
        height: 100%;
        font-size: 14px;
      }
    }
    .block-item:last-child {
      border: none;
    }
  }
}
</style>
